/* One offer ladder; all money comes from Shopify's current product/cart data. */

(function(root) {

 'use strict';

 const H={plate:'meridian-plate',bowl:'meridian-bowl',mug:'meridian-mug',cup:'meridian-cup',cutlery:'meridian-cutlery',duo:'meridian-duo',pour:'the-pour-mug-tumbler-pair',setting:'the-setting-complete-place-setting',full:'the-full-table-complete-collection'};

 const COMPONENTS={duo:['plate','bowl'],pour:['mug','cup'],setting:['plate','bowl','cutlery'],full:['plate','bowl','cutlery','mug','cup']};

 const RULES=[

 {id:'swap-full-table',from:['setting','pour'],to:'full',kind:'saving'},

 {id:'swap-setting',from:['duo','cutlery'],to:'setting',kind:'saving'},

 {id:'swap-duo',from:['plate','bowl'],to:'duo',kind:'saving'},

 {id:'swap-pour',from:['mug','cup'],to:'pour',kind:'saving'},

 {id:'pour-plus-duo-to-full',from:['duo','pour'],to:'full',missing:['cutlery'],kind:'upgrade',exact:true},

 {id:'setting-to-full',from:['setting'],to:'full',missing:['mug','cup'],kind:'upgrade',exact:true},

 {id:'duo-to-setting',from:['duo'],to:'setting',missing:['cutlery'],kind:'upgrade',exact:true},

 {id:'cutlery-to-setting',from:['cutlery'],to:'setting',missing:['plate','bowl'],kind:'upgrade',exact:true},

 {id:'plate-to-duo',from:['plate'],to:'duo',missing:['bowl'],kind:'upgrade',exact:true},

 {id:'bowl-to-duo',from:['bowl'],to:'duo',missing:['plate'],kind:'upgrade',exact:true},

 {id:'mug-to-pour',from:['mug'],to:'pour',missing:['cup'],kind:'upgrade',exact:true},

 {id:'cup-to-pour',from:['cup'],to:'pour',missing:['mug'],kind:'upgrade',exact:true},

 {id:'full-table-second-setting',from:['full'],to:'duo',kind:'add',exact:true}

 ];

 function evaluate(cart,config,dismissed=[]) {

  if(!config.enabled||!cart||!Array.isArray(cart.items)||!cart.items.length)return null;

  if(cart.currency&&cart.currency!==config.currency)return null;

  // Cart/order codes and app discounts can change eligibility when lines are replaced.

  // Keep the customer's current deal unless its full recalculation is known.

  const hasDiscount=cart.total_discount>0||(cart.cart_level_discount_applications||[]).length>0||(cart.discount_codes||[]).some(d=>d.applicable);

  const safeProperties=i=>{

   const keys=Object.keys(i.properties||{});

   if(!keys.length)return true;

   if(keys.length!==1||keys[0]!=='__section_store_bundle'||i.quantity!==1||i.total_discount>0||i.line_level_total_discount>0)return false;

   try{const marker=JSON.parse(i.properties.__section_store_bundle);return typeof marker.bundle_id==='string'&&typeof marker.bundle_option_id==='string'&&Object.keys(marker).every(k=>['bundle_id','bundle_option_id'].includes(k));}catch{return false;}

  };

  const p=config.products||{}, valid=i=>!i.parent_relationship&&!i.selling_plan_allocation&&safeProperties(i);

  for(const rule of RULES){

   if(hasDiscount)continue;

   if(dismissed.includes(rule.id))continue;

   const target=p[H[rule.to]],parts=COMPONENTS[rule.to]||[];

   if(!target?.available||!target.id||parts.some(k=>!p[H[k]]?.available))continue;

   const lines=rule.from.map(k=>cart.items.filter(i=>Number(i.variant_id||i.id)===Number(p[H[k]]?.id)));

   if(lines.some(m=>m.length!==1||!valid(m[0])))continue;

   const selected=lines.map(m=>m[0]);

   if(rule.exact&&cart.items.length!==selected.length)continue;

   // Multi-buy carts retain their own offer; never discard a second piece.

   if(selected.some(i=>i.quantity!==1))continue;

   if(cart.items.some(i=>Number(i.id)===Number(target.id)))continue;

   const removed=rule.kind==='add'?0:selected.reduce((n,i)=>n+i.final_line_price,0);

   const separate=parts.reduce((n,k)=>n+(p[H[k]]?.price||0),0);

   if(separate<=target.price)continue;

   let alternative=removed+(rule.missing||[]).reduce((n,k)=>n+(p[H[k]]?.price||0),0);

   // Existing smaller bundles are another way to buy the same contents.

   if(rule.to==='full'&&rule.from.includes('setting'))alternative=Math.min(alternative,removed+p[H.pour].price);

   if(rule.to==='setting'&&rule.from.includes('cutlery'))alternative=Math.min(alternative,removed+p[H.duo].price);

   const saving=rule.kind==='add'?separate-target.price:alternative-target.price;

   if(saving<=0)continue;

   const delta=target.price-removed;

   if(rule.kind==='saving'&&delta>=0)continue;

   const updates={};

   if(rule.kind!=='add')selected.forEach(i=>updates[i.key]=0);

   updates[String(target.id)]=1;

   return {rule,product:target,quantity:1,updates,sourceKeys:rule.kind==='add'?[]:selected.map(i=>i.key),before:cart.total_price,after:cart.total_price+delta,delta,saving,listSaving:separate-target.price,missing:(rule.missing||[]).map(k=>p[H[k]].title)};

  }

  // An additive suggestion never replaces discounted or multi-buy lines.

  const hasDinnerware=cart.items.some(i=>/meridian-(duo|plate|bowl|dinnerware|complete)/.test(i.handle||''));
  const hasCutlery=cart.items.some(i=>/cutlery|complete-setting|the-setting|full-table/.test(i.handle||''));
  const suggestions=hasCutlery?['pour']:hasDinnerware?['cutlery','pour']:['duo','pour','cutlery','plate','bowl'];

  for(const key of suggestions){

   const id='add-extra-'+key,target=p[H[key]],parts=COMPONENTS[key]||[key];

   if(dismissed.includes(id)||!target?.id||!target.available||parts.some(k=>!p[H[k]]?.available))continue;

   if(cart.items.some(i=>Number(i.variant_id||i.id)===Number(target.id)||i.handle===H[key]))continue;
   const separate=parts.reduce((sum,k)=>sum+p[H[k]].price,0);

   return {rule:{id,to:key,from:[],kind:'add',additive:true},product:target,quantity:1,updates:{},sourceKeys:[],before:cart.total_price,after:cart.total_price+target.price,delta:target.price,saving:Math.max(0,separate-target.price),listSaving:Math.max(0,separate-target.price),missing:[]};

  }

  return null;

 }

 function fingerprint(cart){return JSON.stringify([cart.currency,cart.total_price,cart.total_discount,(cart.items||[]).map(i=>[i.key,i.quantity,i.final_line_price]),cart.discount_codes||[]]);}

 const api={H,COMPONENTS,RULES,evaluate,fingerprint};

 root.NCBundleRules=api;

 if(typeof module!=='undefined'&&module.exports)module.exports=api;

})(typeof window==='undefined'?globalThis:window);

